import { decode } from 'blurhash';

function blurHashToDataURL(hash, width, height, punch) {
  var pixels = decode(hash, width, height, punch);
  var dataURL = parsePixels(pixels, width, height);
  return dataURL;
}
// thanks to https://github.com/wheany/js-png-encoder
function parsePixels(pixels, width, height) {
  var pixelsString = [].concat(pixels).map(function (_byte) {
    return String.fromCharCode(_byte);
  }).join("");
  var pngString = generatePng(width, height, pixelsString);
  var dataURL = typeof Buffer !== "undefined" ? Buffer.from(getPngArray(pngString)).toString("base64") : btoa(pngString);
  return "data:image/png;base64," + dataURL;
}
function getPngArray(pngString) {
  var pngArray = new Uint8Array(pngString.length);
  for (var i = 0; i < pngString.length; i++) {
    pngArray[i] = pngString.charCodeAt(i);
  }
  return pngArray;
}
function generatePng(width, height, rgbaString) {
  var DEFLATE_METHOD = String.fromCharCode(0x78, 0x01);
  var CRC_TABLE = [];
  var SIGNATURE = String.fromCharCode(137, 80, 78, 71, 13, 10, 26, 10);
  var NO_FILTER = String.fromCharCode(0);
  var n, c, k;
  // make crc table
  for (n = 0; n < 256; n++) {
    c = n;
    for (k = 0; k < 8; k++) {
      if (c & 1) {
        c = 0xedb88320 ^ c >>> 1;
      } else {
        c = c >>> 1;
      }
    }
    CRC_TABLE[n] = c;
  }
  // Functions
  function inflateStore(data) {
    var MAX_STORE_LENGTH = 65535;
    var storeBuffer = "";
    var remaining;
    var blockType;
    for (var i = 0; i < data.length; i += MAX_STORE_LENGTH) {
      remaining = data.length - i;
      blockType = "";
      if (remaining <= MAX_STORE_LENGTH) {
        blockType = String.fromCharCode(0x01);
      } else {
        remaining = MAX_STORE_LENGTH;
        blockType = String.fromCharCode(0x00);
      }
      // little-endian
      storeBuffer += blockType + String.fromCharCode(remaining & 0xFF, (remaining & 0xFF00) >>> 8);
      storeBuffer += String.fromCharCode(~remaining & 0xFF, (~remaining & 0xFF00) >>> 8);
      storeBuffer += data.substring(i, i + remaining);
    }
    return storeBuffer;
  }
  function adler32(data) {
    var MOD_ADLER = 65521;
    var a = 1;
    var b = 0;
    for (var i = 0; i < data.length; i++) {
      a = (a + data.charCodeAt(i)) % MOD_ADLER;
      b = (b + a) % MOD_ADLER;
    }
    return b << 16 | a;
  }
  function updateCrc(crc, buf) {
    var c = crc;
    var b;
    for (var _n = 0; _n < buf.length; _n++) {
      b = buf.charCodeAt(_n);
      c = CRC_TABLE[(c ^ b) & 0xff] ^ c >>> 8;
    }
    return c;
  }
  function crc(buf) {
    return updateCrc(0xffffffff, buf) ^ 0xffffffff;
  }
  function dwordAsString(dword) {
    return String.fromCharCode((dword & 0xFF000000) >>> 24, (dword & 0x00FF0000) >>> 16, (dword & 0x0000FF00) >>> 8, dword & 0x000000FF);
  }
  function createChunk(length, type, data) {
    var CRC = crc(type + data);
    return dwordAsString(length) + type + data + dwordAsString(CRC);
  }
  function createIHDR(width, height) {
    var IHDRdata = dwordAsString(width) + dwordAsString(height) +
    // bit depth
    String.fromCharCode(8) +
    // color type: 6=truecolor with alpha
    String.fromCharCode(6) +
    // compression method: 0=deflate, only allowed value
    String.fromCharCode(0) +
    // filtering: 0=adaptive, only allowed value
    String.fromCharCode(0) +
    // interlacing: 0=none
    String.fromCharCode(0);
    return createChunk(13, "IHDR", IHDRdata);
  }
  // PNG creations
  var IEND = createChunk(0, "IEND", "");
  var IHDR = createIHDR(width, height);
  var scanlines = "";
  var scanline;
  for (var y = 0; y < rgbaString.length; y += width * 4) {
    scanline = NO_FILTER;
    if (Array.isArray(rgbaString)) {
      for (var x = 0; x < width * 4; x++) {
        scanline += String.fromCharCode(rgbaString[y + x] & 0xff);
      }
    } else {
      scanline += rgbaString.substr(y, width * 4);
    }
    scanlines += scanline;
  }
  var compressedScanlines = DEFLATE_METHOD + inflateStore(scanlines) + dwordAsString(adler32(scanlines));
  var IDAT = createChunk(compressedScanlines.length, "IDAT", compressedScanlines);
  var pngString = SIGNATURE + IHDR + IDAT + IEND;
  return pngString;
}

function useBlurData(blurHash, width, height, punch) {
  if (width === void 0) {
    width = 160;
  }
  if (height === void 0) {
    height = 120;
  }
  return [blurHashToDataURL(blurHash, width, height, punch)];
}

export default useBlurData;
//# sourceMappingURL=use-next-blurhash.esm.js.map
